import React from 'react';
import { Zap, FileText, Users, DollarSign, BarChart3, Mail } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import BackButton from '../../../components/admin/BackButton';

const AssistantActions = () => {
  const actions = [
    {
      title: "Generate Invoice",
      description: "Quickly create invoices for clients",
      icon: FileText,
      color: "bg-blue-500"
    },
    {
      title: "Add Contact",
      description: "Add new contacts to CRM",
      icon: Users,
      color: "bg-green-500"
    },
    {
      title: "Financial Report",
      description: "Generate financial summary",
      icon: DollarSign,
      color: "bg-yellow-500"
    },
    {
      title: "Analytics Dashboard",
      description: "View platform analytics",
      icon: BarChart3,
      color: "bg-purple-500"
    },
    {
      title: "Send Email",
      description: "Compose and send emails",
      icon: Mail,
      color: "bg-red-500"
    }
  ];

  return (
    <div>
      <BackButton />
      
      <div className="mb-8">
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-yellow-500 bg-opacity-10 rounded-lg">
            <Zap className="h-6 w-6 text-yellow-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#2B2D42]">Quick Actions</h2>
            <p className="text-sm text-[#6C757D]">Perform common tasks with one click</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {actions.map((action, index) => {
          const Icon = action.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className={`${action.color} p-3 rounded-lg w-fit mb-4`}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <CardTitle>{action.title}</CardTitle>
                <CardDescription>{action.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <Button variant="outline" className="w-full" disabled>
                  Coming Soon
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="mt-8 bg-yellow-50 border-yellow-200">
        <CardContent className="pt-6">
          <p className="text-sm text-[#6C757D]">
            ⚡ <strong>Quick Actions</strong> will allow you to perform common platform tasks with a single click. 
            This feature is under development.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssistantActions;